customElements.get("product-form") ||
    customElements.define(
        "product-form",
        class t extends HTMLElement {
            constructor() {
                super(),
                    (this.form = this.querySelector("form")),
                    (this.form.querySelector("[name=id]").disabled = !1),
                    this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                    (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
                    (this.submitButton = this.querySelector('[type="submit"]')),
                    document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
                    (this.hideErrors = "true" === this.dataset.hideErrors);
            }
           onSubmitHandler(t) {
    console.log("Submit Handler Triggered");
    t.preventDefault();

    if ("true" === this.submitButton.getAttribute("aria-disabled")) {
        console.log("Submit button is disabled. Exiting function.");
        return;
    }
      let e = setInterval(function () {
  
    if ($(".cart-item.freeProduct").length > 0) {

        var t = $("#cartfreeproduct").val();
        console.log("Product ID:", t);

        var r = $("#cartfreeproduct").attr("data-cart-limit");
        console.log("Cart Limit (Data Attribute):", r);

        var s = parseFloat(r);
        console.log("Cart Limit as Float:", s);

        $.ajax({
            type: "POST",
            url: "/cart",
            dataType: "json",
            async: !1,
            success: function (r) {
                console.log("Cart Data:", r);

                if ("" != r.total_price || void 0 != r.total_price) {
                    console.log("Valid total_price found:", r.total_price);
                    clearInterval(e); 

                    var i = r.total_price / 100;
                    console.log("Total Price in Dollars:", i);

                    if (0 == $(".cart-item.freeProduct").length && i > s) {
                        console.log("Adding Free Gift to Cart");
                        jQuery.ajax({
                            type: "POST",
                            url: "/cart/add.js",
                            async: !1,
                            data: { 
                                quantity: 1, 
                                id: t, 
                                properties: { "_Free-Gift": "Free-Gift" } 
                            },
                            dataType: "json",
                            success: function (t) {
                                console.log("Free Gift Added:", t);
                            
                                $.ajax({
                                    url: "/cart",
                                    type: "GET",
                                    dataType: "html",
                                    success: function (t) {
                                        console.log("Updating Cart Drawer with New Items");
                                        $("cart-drawer-items").html($(t).find("cart-drawer-items").html());
                                       
                                    },
                                });
                            },
                        });
                    }
                }
            },
        });

    }
}, 500);



                this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("loading"), this.querySelector(".loading__spinner").classList.remove("hidden");
                let r = fetchConfig("javascript");
                (r.headers["X-Requested-With"] = "XMLHttpRequest"), delete r.headers["Content-Type"];
                let s = new FormData(this.form);
                this.cart &&
                    (s.append(
                        "sections",
                        this.cart.getSectionsToRender().map((t) => t.id)
                    ),
                    s.append("sections_url", window.location.pathname),
                    this.cart.setActiveElement(document.activeElement)),
                    (r.body = s),
                    fetch(`${routes.cart_add_url}`, r)
                        .then((t) => t.json())
                        .then((t) => {
                            if (t.status) {
                                publish(PUB_SUB_EVENTS.cartError, { source: "product-form", productVariantId: s.get("id"), errors: t.errors || t.description, message: t.message }), this.handleErrorMessage(t.description);
                                let e = this.submitButton.querySelector(".sold-out-message");
                                if (!e) return;
                                this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.querySelector("span").classList.add("hidden"), e.classList.remove("hidden"), (this.error = !0);
                                return;
                            }
                            if (!this.cart) {
                                window.location = window.routes.cart_url;
                                return;
                            }
                            this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: s.get("id"), cartData: t }), (this.error = !1);
                            let r = this.closest("quick-add-modal");
                            r
                                ? (document.body.addEventListener(
                                      "modalClosed",
                                      () => {
                                          setTimeout(() => {
                                              this.cart.renderContents(t);
                                          });
                                      },
                                      { once: !0 }
                                  ),
                                  r.hide(!0))
                                : this.cart.renderContents(t);
                        })
                        .catch((t) => {
                            console.error(t);
                        })
                        .finally(() => {
                            this.submitButton.classList.remove("loading"),
                                this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                                this.error || this.submitButton.removeAttribute("aria-disabled"),
                                this.querySelector(".loading__spinner").classList.add("hidden");
                        });
            }
            handleErrorMessage(t = !1) {
                !this.hideErrors &&
                    ((this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                    this.errorMessageWrapper &&
                        ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")), this.errorMessageWrapper.toggleAttribute("hidden", !t), t && (this.errorMessage.textContent = t)));
            }
        }
    );


document.addEventListener('DOMContentLoaded', function () {
  initVariantImageGallery();
});

function initVariantImageGallery() {
  const variantInputs = document.querySelectorAll('.input-label-wrapper input[type="radio"]');

  // Onload: trigger for already-checked variant
  const checkedInput = document.querySelector('.input-label-wrapper input[type="radio"]:checked');
  if (checkedInput) {
    const label = checkedInput.nextElementSibling;
    if (label) updateGallery(label);
  }

  variantInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      const label = this.nextElementSibling; 
      if (label) updateGallery(label);
    });
  });
}

function updateGallery(label) {
  
  const hiddenImg = label.querySelector('.variantfirstimg');
  if (!hiddenImg) return;

  const newSrc = hiddenImg.getAttribute('src');
  if (!newSrc || newSrc.trim() === '') return;

  
  const carouselCells = document.querySelectorAll('.carousel-cell');
  
  if (carouselCells.length === 0) return;

  
  const firstCell = carouselCells[0];
  const mainImg = firstCell.querySelector('img');
  if (mainImg) {
    mainImg.setAttribute('src', newSrc.trim());
   
    mainImg.removeAttribute('srcset');
  }

 
  const carousel = document.querySelector('.flickity-enabled');
  if (carousel && window.Flickity) {
    const flkty = Flickity.data(carousel);
    if (flkty) {
      flkty.select(0); 
    }
  }
}






function updateGallery(label) {
  const hiddenImg = label.querySelector('.variantfirstimg');
  if (!hiddenImg) return;

  const newSrc = hiddenImg.getAttribute('src');
  if (!newSrc || newSrc.trim() === '') return;

 
  const variantSlide = document.querySelector('.carousel-main .swiper-slide.variant_specific_image');
  
 
  const targetSlide = variantSlide || document.querySelector('.carousel-main .swiper-slide');
  
  if (!targetSlide) return;

  const mainImg = targetSlide.querySelector('img');
  if (mainImg) {
    mainImg.setAttribute('src', newSrc.trim());
    mainImg.removeAttribute('srcset');
  }


  const thumbVariantSlide = document.querySelector('.carousel-main-new .swiper-slide.variant_specific_image');
  const targetThumb = thumbVariantSlide || document.querySelector('.carousel-main-new .swiper-slide');
  if (targetThumb) {
    const thumbImg = targetThumb.querySelector('img');
    if (thumbImg) {
      thumbImg.setAttribute('src', newSrc.trim());
      thumbImg.removeAttribute('srcset');
    }
  }

  if (typeof mainSwiper !== 'undefined' && mainSwiper) {
    mainSwiper.slideTo(0, 0);
    mainSwiper.update();
  }
  if (typeof thumbSwiper !== 'undefined' && thumbSwiper) {
    thumbSwiper.slideTo(0, 0);
    thumbSwiper.update();
  }
}